import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post } from '../../../common/api'
import { GET_DASHBOARD } from '../../../common/constant'


export const actionGetDashboard = createAsyncThunk('appDashboard/actionGetDashboard', async (params, thunkAPI) => {
    return await post(GET_DASHBOARD, params, thunkAPI)
})

export const appDashboardSlice = createSlice({
    name: 'appDashboard',
    initialState: {

        //get
        loadingGet: false,
        getDashboard: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetGetDashboardResponse: (state) => {
            state.getDashboard = null
        }
    },
    extraReducers: builder => {
        builder

            //get
            .addCase(actionGetDashboard.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetDashboard.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getDashboard = action.payload
            })
            .addCase(actionGetDashboard.rejected, (state) => {
                state.loadingGet = false
            })
    }
})
export const { resetGetDashboardResponse } = appDashboardSlice.actions

export default appDashboardSlice.reducer